import React, {useContext, useEffect} from "react";
import {boardUrl, logoUrl, TITLE} from "../../config/config";
import Body from "../common/Body";
import {generateHeadTags} from "react-seo-tools";
import {Helmet} from "react-helmet";
import VideoItemHeader from "./section/VideoItemHeader";
import {VideoItemContext, VideoItemProvider} from "../../context/videoItemContext";
import VideoItemActionButtons from "./section/VideoItemActionButtons";
import CommentList from "./section/CommentList";
import {MediaPlayer, MediaProvider} from "@vidstack/react";
import {defaultLayoutIcons, DefaultVideoLayout} from "@vidstack/react/player/layouts/default";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTimes} from "@fortawesome/free-solid-svg-icons";

const MainContent = () => {
	const {video} = useContext(VideoItemContext);

	useEffect(() => {
		import("../../assets/video_mobile.css");

		if (video) {
			document.title = `${video.thread_title} | ${TITLE}`;
			document.querySelector('meta[name="description"]').setAttribute("content", video.Thread.excerpt);
		}

		return () => {
			const link = document.querySelector('link[href="../../assets/video_mobile.css"]');
			if (link) {
				link.parentNode.removeChild(link);
			}
		};
	}, [video]);

	return (
		<div>
			{video && (
				<Helmet>
					{generateHeadTags({
						title: video.thread_title,
						description: video.Thread.excerpt,
						openGraph: {
							type: 'video.other',
							title: video.thread_title,
							image: video.Thread.thumbnail_url,
							'video:director': video.Thread.username,
							'video:release_date': video.Thread.post_date_meta_tag,
							'video:tag': video.Thread.tags
						},
					})}
				</Helmet>
			)}

			{video && (
				<div className="flex w-full h-screen overflow-hidden">
					<div className="relative flex-1 min-w-0 h-full">
						<div className="absolute top-5 left-5 z-20">
							<div className="flex items-center gap-x-4">
								<a href={`${boardUrl}/videos/`} className="bg-primary bg-opacity-35 inline-flex items-center justify-center w-[48px] h-[48px] rounded-full text-white hover:bg-opacity-65">
									<FontAwesomeIcon icon={faTimes} />
								</a>

								<a href={boardUrl} title={TITLE}>
									<img src={logoUrl} alt={TITLE} className="w-auto h-14" />
								</a>
							</div>
						</div>

						<div className="w-full h-full">
							<MediaPlayer
								title={video.Attachment.filename}
								src={video.Attachment.direct_url}
								className="w-full h-full"
								autoplay={true}
								loop
							>
								<MediaProvider className="w-full h-full" />
								<DefaultVideoLayout icons={defaultLayoutIcons} />
							</MediaPlayer>
						</div>
					</div>

					<div className="w-1/3 h-auto flex flex-col bg-secondary bg-opacity-85 border-l border-borderColor flex-shrink-0 flex-grow-0">
						<div className="p-8 border-b border-borderColor">
							<div className="mb-4">
								<VideoItemHeader video={video} />
							</div>

							<div className="mb-4">
								<VideoItemActionButtons video={video} />
							</div>
						</div>

						<div className="flex-grow overflow-x-hidden overflow-y-auto">
							<CommentList video={video} isActive={true} isForVideoView={true} />
						</div>
					</div>
				</div>
			)}
		</div>
	);
}

const VideoView = () => {
	return (
		<VideoItemProvider>
			<Body mainContent={<MainContent/>} />
		</VideoItemProvider>
	);
}

export default VideoView;